export default class User {

    id = null
    azure_id = null
    first_name = null
    last_name = null
    email = null
    active = 0
    level = 1
    name = null
    meta = {
        photo: null,
        prefs: {
            tables: [],
            notification_type: null,
            notification_frequency: null
        }
    }
    $image = null
    last_login = null
    created_at = null
    updated_at = null
    deleted_at = null

    constructor(data) {
        this.id = data?.id ?? this.id;
        this.azure_id = data?.azure_id ?? this.azure_id;
        this.first_name = data?.first_name ?? this.first_name;
        this.last_name = data?.last_name ?? this.last_name;
        this.email = data?.email ?? this.email;
        this.active = data?.active ?? this.active;
        this.level = data?.level ?? this.level;
        this.name = data?.name ?? this.name;
        this.meta = data?.meta ?? this.meta;
        this.$image = data?.image ?? this.$image;
        this.last_login = data?.last_login ?? this.last_login;
        this.created_at = data?.created_at ?? this.created_at;
        this.updated_at = data?.updated_at ?? this.updated_at;
        this.deleted_at = data?.deleted_at ?? this.deleted_at;
        
        return this
    }

    get fullName() {
        return `${this.first_name ?? ''} ${this.last_name ?? ''}`
    }

    get image() {
        return this.$image && `${import.meta.env.VITE_APP_ENDPOINT}api/users/${this.id}/photo`
    }

}